const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan1 from './img-10.jpg';
import floorplan2 from './img-27.jpg';

const floorPlanFiles = new Set(['./img-10.jpg', './img-27.jpg']);

export const lounyImages: string[] = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const lounyFloorPlans = [
  { image: floorplan1, label: "Půdorys domu – 3D" },
  { image: floorplan2, label: "Půdorys domu – 2D" },
];
